<vtr-page-layout [title]="'settings.preferenceSettings' | translate"
	[back]="'common.ui.back' | translate"
	[textId]="'myDevice-settings'"
	[pageCssClass]="'preference-settings'"
	[backId]="backId"
	[shiftLeftUp]="false"
	[vtrAppSearchScroller]="['search-preference-subscription']"
	[shiftRightUp]="true">

	<left-content>
		<div class="row no-gutters justify-content-center">
			<div class="col-12 settings-main-column">
				<div class="subpage-settings vtr-subpage">
					<vtr-ui-header-subpage [title]="'settings.settings' | translate"
						[caption]="'settings.settingsDescription' | translate">
					</vtr-ui-header-subpage>

					<div class="card-pt" *ngIf="isMessageSettings"
						id="settings-messages">
						<vtr-container-collapsible name="SettingsMessage"
							[tabIndex]="0"
							collapseLinkId="settings-message"
							[cardTitle]="'settings.messagesInLenovoVantage' | translate"
							[isCollapsed]="false">
							<ul class="list-group list-group-flush">
								<li>
									<vtr-ui-row-switch [title]="'settings.actionTriggered' | translate"
										[vtrAppSearchScroller]="['search-preference-action-trigger']"
										[name]="'ActionTriggeredToggle'"
										[switchId]="'settingsActionTriggeredToggle'"
										id="settings-actionTriggeredToggle"
										aria-label="settings-actionTriggeredToggle"
										[caption]="'settings.actionTriggeredDescription' | translate"
										[isLastChild]=true
										[isSwitchVisible]=true
										[leftIcon]="messageSettings[2].leftImageSource"
										[tooltipText]=""
										[isSwitchChecked]="toggleActionTriggered"
										(toggleOnOff)="onToggleOfActionTriggered($event)">
									</vtr-ui-row-switch>
								</li>

							</ul>
						</vtr-container-collapsible>
					</div>

					<div id="settings-note" class="mt-5">
						<div class="settings-note">
							<b>{{ 'settings.Note' | translate }}</b>{{ 'settings.settingsNotes' | translate }}
						</div>
					</div>

				</div>
			</div>
		</div>
	</left-content>

</vtr-page-layout>
